export default __webpack_public_path__ + "915d08e1f8b623374ddd1ba7f6a45fa0.png";